module.exports = __webpack_public_path__ + "media/application/images/icons/calendar-4d44fe2e0cd57fac8c6549e941982f18.svg";